import '@/lib/typedef';
import { buildQuery } from '@/lib/helper';
import client from '@/lib/http-client';

const endpoint = '/product-request';

/**
 * Fetch All Product Requests
 *
 * @param {Object} params
 * @param {number} params.limit Limit
 * @param {'created_at'} params.sort_by Sort By
 * @param {'desc' | 'asc'} params.sort Sort
 * @param {number} params.page Page
 * @param {requestCallback} cb
 * @param {errorCallback} errorCb
*/
export const getProductRequests = (params, cb, errorCb) => {
	const query = buildQuery(params);
	const url = `${endpoint}?${query}`;
	client.get(url)
		.then((response) => {
			cb(response.data);
		})
		.catch((e) => {
			errorCb(e);
		});
};

/**
 * Create Product Request
 *
 * @param {Object} params
 * @param {Object} params.category Category
 * @param {string} params.description Description
 * @param {number} params.price Recommended Price
 * @param {string} params.revenue Revenue
 * @param {requestCallback} cb
 * @param {errorCallback} errorCb
*/
export const createProductRequest = (params, cb, errorCb) => {
	const url = `${endpoint}`;
	client.post(url, params)
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

/**
 * Update Product Request
 *
 * @param {string} id Product Request ID
 * @param {Object} params
 * @param {Object} params.category Category
 * @param {string} params.description Description
 * @param {number} params.price Recommended Price
 * @param {string} params.revenue Revenue
 * @param {requestCallback} cb
 * @param {errorCallback} errorCb
*/
export const updateProductRequest = (id, params, cb, errorCb) => {
	const url = `${endpoint}/${id}`;
	client.put(url, params)
		.then((response) => {
			cb(response.data);
		})
		.catch((e) => {
			errorCb(e);
		});
};
